module.exports = __webpack_public_path__ + "static/media/windows-store.f0450282.svg";